<template>
    <div class="honour">
        <div class="img-header">
            <img src="@/assets/image/honour.png" alt="荣誉与资质" class="honour-image" />
        </div>
        <div class="additional-section">
        </div>
        <div class="honours-section">
            <div class="honour-page" v-for="(page, pageIndex) in paginatedHonours" :key="pageIndex">
                <div class="honour-item" v-for="(honour, index) in page" :key="index">
                    <img :src="honour.image" :alt="honour.name" class="honour-item-image" @click="showModal(honour.image)" />
                    <p class="honour-item-name">{{ honour.name }}</p>
                </div>
            </div>
        </div>
        <div class="pagination">
            <button @click="prevPage" :disabled="currentPage === 0">上一页</button>
            <span>{{ currentPage + 1 }} / {{ totalPages }}</span>
            <button @click="nextPage" :disabled="currentPage === totalPages - 1">下一页</button>
        </div>
        <div class="footer-section">
            <div class="footer-left">
                <p>版权所有 © 2025 百亩林</p>
                <router-link to="/honour" class="license-link">营业执照</router-link>
            </div>
            <div class="footer-right">
                <p>备案号：XYZ123456789</p>
                <!-- <div class="qr-code">
                    <img src="@/assets/image/logo.png" alt="二维码" class="qr-image" />
                </div> -->
            </div>
        </div>

        <!-- 模态框 -->
        <div class="modal" v-if="showModalFlag" @click="closeModal">
            <div class="modal-content" @click.stop>
                <span class="close" @click="closeModal">&times;</span>
                <img :src="selectedImage" alt="Enlarged Image" class="modal-image" />
            </div>
        </div>
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue'; // 引入 Footer 组件
const requireContext = require.context('@/assets/image/honours', false, /\.jpg$/);
const images = requireContext.keys().map(requireContext);

export default {
    name: 'Honour',
    components: {
        Footer
    },
    data() {
        return {
            honours: [
                {
                    id: 1,
                    name: '文化使者荣誉证书',
                    image: images[0]
                },
                {
                    id: 2,
                    name: '全国名特优新农产品',
                    image: images[1]
                },
                {
                    id: 3,
                    name: '全国名特优新农产品附证',
                    image: images[2]
                },
                {
                    id: 4,
                    name: '最受欢迎产品证书',
                    image: images[3]
                },
                {
                    id: 5,
                    name: '优秀学员示范基地',
                    image: images[4]
                }
            ],
            currentPage: 0,
            honoursPerPage: 8, // 每页显示8个荣誉项
            showModalFlag: false,
            selectedImage: ''
        };
    },
    computed: {
        paginatedHonours() {
            const start = this.currentPage * this.honoursPerPage;
            const end = start + this.honoursPerPage;
            const honoursSlice = this.honours.slice(start, end);
            const pages = [];
            for (let i = 0; i < honoursSlice.length; i += 4) {
                pages.push(honoursSlice.slice(i, i + 4));
            }
            return pages;
        },
        totalPages() {
            return Math.ceil(this.honours.length / this.honoursPerPage);
        }
    },
    methods: {
        nextPage() {
            if (this.currentPage < this.totalPages - 1) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 0) {
                this.currentPage--;
            }
        },
        showModal(image) {
            this.selectedImage = image;
            this.showModalFlag = true;
        },
        closeModal() {
            this.showModalFlag = false;
        }
    }
}
</script>

<style scoped>
.honour {
    text-align: center;
    padding-top: 40px;
}

.img-header {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.honour-image {
    max-height: 250px;
    width: 100%;
}

.honours-section {
    margin: 40px 0;
    padding: 20px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    width: 80%;
    max-width: 1200px;
    margin: 0 auto;
    height: 480px;
    overflow-y: auto; /* 如果荣誉项过多，可以滚动 */
}

.honour-page {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.honour-item {
    width: 22%; /* 每个荣誉项占22%宽度，留出2%的间距 */
    height: 200px; /* 设置固定的高度 */
    background-color: #f0f0f0;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px;
    margin-bottom: 20px; /* 添加底部间距以确保每行四个荣誉项 */
    box-sizing: border-box; /* 确保内边距和边框不会影响宽度 */
    cursor: pointer; /* 添加鼠标悬停效果 */
    transition: background-color 0.3s, color 0.3s; /* 添加过渡效果 */
}

/* rgb(0, 132, 96) */
.honour-item:hover {
    background-color: #28a745;
    color: white; /* 字体变为白色 */
}

.honour-item:hover .honour-item-image {
    transform: scale(1.1); /* 图片放大 10% */
    transition: transform 0.3s; /* 添加过渡效果 */
}

.honour-item-image {
    max-width: 100px;
    height: auto;
    margin-bottom: 10px;
    transition: transform 0.3s; /* 添加过渡效果 */
}

.honour-item-name {
    margin: 0;
    font-size: 16px;
    flex-grow: 1; /* 使名称部分可以伸缩以适应剩余空间 */
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
}

.pagination button {
    background-color: #007bff;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 5px;
}

.pagination button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.pagination span {
    margin: 0 10px;
    font-size: 16px;
}

.footer-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-top: 1px solid #ccc;
}

.footer-left {
    flex: 1;
    text-align: left;
}

.footer-left p {
    margin: 5px 0;
}

.footer-left .license-link {
    color: blue;
    text-decoration: none;
}

.footer-right {
    flex: 1;
    text-align: right;
}

.footer-right p {
    margin: 5px 0;
}

.qr-code {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.qr-image {
    width: 100px;
    height: 100px;
    object-fit: cover;
    margin-top: 10px;
}

/* 模态框样式 */
.modal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 1000;
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    max-width: 80%;
    max-height: 80%;
    overflow: auto;
    position: relative;
}

.modal-image {
    max-width: 50%;
    height: auto;
    display: block;
    margin: 0 auto;
}

.close {
    position: absolute;
    top: 10px;
    right: 20px;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
}

.close:hover,
.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

.additional-section {
    height: 30px; /* 设置高度为100px */
    background-color: white; /* 可选：设置背景颜色 */
    margin: 20px 0; /* 可选：设置上下间距 */
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .honour {
        padding-top: 20px;
    }

    .img-header {
        margin-bottom: 20px;
    }

    .honour-image {
        max-height: 200px;
    }

    .honours-section {
        width: 95%;
        height: auto;
        max-height: 600px;
        padding: 15px;
        margin: 20px auto;
    }

    .honour-page {
        margin-bottom: 15px;
    }

    .honour-item {
        width: 45%;
        height: 180px;
        margin-bottom: 15px;
        padding: 8px;
    }

    .honour-item-image {
        max-width: 80px;
    }

    .honour-item-name {
        font-size: 14px;
        margin-top: 8px;
    }

    .pagination {
        margin: 15px 0;
    }

    .pagination button {
        padding: 8px 16px;
        font-size: 14px;
    }

    .pagination span {
        font-size: 14px;
    }

    .modal-content {
        width: 95%;
        padding: 15px;
    }

    .modal-image {
        max-width: 100%;
    }

    .close {
        font-size: 24px;
        right: 15px;
        top: 8px;
    }
}

@media screen and (max-width: 480px) {
    .honour-image {
        max-height: 150px;
    }

    .honours-section {
        width: 98%;
        padding: 10px;
    }

    .honour-item {
        width: 48%;
        height: 160px;
        margin-bottom: 12px;
        padding: 6px;
    }

    .honour-item-image {
        max-width: 70px;
    }

    .honour-item-name {
        font-size: 12px;
        margin-top: 6px;
    }

    .pagination button {
        padding: 6px 12px;
        font-size: 12px;
    }

    .pagination span {
        font-size: 12px;
    }

    .modal-content {
        width: 98%;
        padding: 12px;
    }

    .close {
        font-size: 20px;
        right: 12px;
        top: 6px;
    }
}
</style>